module.exports = __webpack_public_path__ + "img/team-vladimir.f5344c4d.jpg";